import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TransactionStatesEnum } from '@app/core/enums/transaction-states.enum';
import { Transaction } from '@app/transactions/transaction';

@Component({
    selector: 'app-btn-transaction-details',
    templateUrl: './btn-transaction-details.component.html',
    styleUrls: ['./btn-transaction-details.component.scss']
})
export class BtnTransactionDetailsComponent {
    @Input() public transaction: Transaction = new Transaction();
    public stateEnum: typeof TransactionStatesEnum = TransactionStatesEnum;

    public constructor(private router: Router) {}

    public goToDetail(event: Event): void {
        event.stopPropagation();
        let routeRedirect: string = '/my/dashboard/transactions/v3/' + this.transaction.id;
        if (this.transaction.attributes.state === 16) {
            this.router.navigate(['/my/dashboard/validations']);

            return;
        }
        this.router.navigate([routeRedirect + '/instructions']);
    }
}
